<template>
    <div class="menu-item" @click="$emit('toshow', MenuItem)">
        <div class="menu-item-image-container">
            <img :src="image" @error="imageerror"/>
        </div>
        <div class="menu-item-data">
            <span class="menu-item-name">{{MenuItem.name}}</span>
            <span class="menu-item-price">{{(MenuItem.price /100 ).toFixed(0)}}</span>
        </div>
        
        <!--<span class="exceptor">{{MenuItem.recipe}}</span>
        <div class="menu-item-hover">
            <div class="menu-item-name">{{MenuItem.name}}</div>
            <pre class="menu-item-recipe">{{MenuItem.recipe}}</pre>
            <div class="menu-item-footer">
            <span class="menu-item-price">{{(MenuItem.price /100 ).toFixed(0)}}р.</span>
            <MenuItemSpin :MenuItem="MenuItem" :Summed="false"/>
            </div>
        </div>
        <MenuItemSpin :MenuItem="MenuItem" :Summed="false"/>-->
    </div>
</template>

<script>
/*import MenuItemSpin from './MenuItemSpin'*/
export default {
    props: ['MenuItem', 'shop'],
    data(){
        return {
            picError: false
        }
    },
    methods:{
        inc: function (){
            if (this.MenuItem.qty){
                this.MenuItem.qty += 1
            } else {
                this.MenuItem.qty = 1
            }
            this.MenuItem.sum = this.MenuItem.price * this.MenuItem.qty
        },
        dec: function (){
            if (this.MenuItem.qty){
                if (this.MenuItem.qty > 0){
                    this.MenuItem.qty -= 1
                }
                this.MenuItem.sum = this.MenuItem.price * this.MenuItem.qty
            }
        },
        imageerror(){
            if (this.picError == false) {
                this.picError = true
            }
        },
        show(){
            if (window.innerWidth < 542){
                
                this.$popup('<div id="dishpopup"><h2>'+this.MenuItem.name+'</h2><img style="height: auto; max-width: 100%" src="'+this.image+'"><pre style="max-width: 100%; text-align: left; white-space: pre-line">'+this.MenuItem.recipe+'</pre></div>')
            }
        }
    },
    computed:{
        normalizedRecipe(){
            //return this.MenuItem.recipe.replace('\n','</br>')
            return this.MenuItem.recipe
        },
        image(){
            if (this.picError == true) {
                return this.shop.noimage
            } else {
                return this.shop.imagesurl+this.MenuItem.code+'.png'
            }
        }
    },
    components: {
        /*MenuItemSpin*/
    }
}
</script>